
<template>
    <div class="table-com">
        <div class="describe">发送了表格，您可以：</div>

        <div class="tools-bar">
            <div
                @click="showType = 2"
                v-if="showType == 1 && chartColumns && chartColumns.length > 1"
                class="btn"
            >
                <i class="el-icon-s-data icon"></i>
                <span class="text">查看柱状图</span>
            </div>

            <div @click="showType = 1" v-if="showType == 2" class="btn">
                <i class="el-icon-s-grid icon"></i>
                <span class="text">查看数据表</span>
            </div>

        </div>

        <div class="title">{{ title }}</div>
        <!-- 表格 -->
        <div v-if="showType == 1">
            <el-table
                :data="list"
                border
                :show-summary="!!(summaryKeys && summaryKeys.length)"
                :summary-method="summaryMethod"
            >
                <el-table-column
                    v-for="(value, key, index) in list[0]"
                    :key="key + index"
                    :label="key"
                    :prop="key"
                ></el-table-column>
            </el-table>
        </div>
        <!-- 图表 -->
        <div v-else-if="showType == 2">
            <ve-chart
                :extend="chartExtend"
                :colors="colors"
                :data="chartData"
                :settings="chartSettings"
            ></ve-chart>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "vTable",
    props: {
        isPage: {
            type: Boolean,
            default: false,
        },
        json: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showType: 1, //1表格  2图
            // 图
            chartExtend: {
                series: {},
            },
            colors: ["#34a853", "#fbbc05", "#ea4335", "#4285f4", "#585455"],
            chartSettings: {
                type: "histogram",
            },
        };
    },
    computed: {
        chartData() {
            let list = this.list;

            let data = {
                columns: this.chartColumns,
            };

            data.rows = list;

            return data;
        },

        /**
         * 下面为传入的数据
         */
        // 类型  table
        type() {
            return this.json.type;
        },
        // 标题  String  为空则不显示
        title() {
            return this.json.title;
        },
        // 表格上的合计列  Array[String]  为空则不显示合计
        summaryKeys() {
            return this.json.summaryKeys;
        },
        // 柱状图的 横坐标 / 纵坐标(纵坐标可为多个)   Array[String]  为空则不能转换Wie柱状图
        chartColumns() {
            return this.json.chartColumns;
        },
        // 表格内容  Array[Object]  必传
        list() {
            return this.json.list;
        },
    },
    beforeDestroy() {},
    created() {},
    methods: {
        summaryMethod(obj) {
            let arr = [];

            for (let i = 0, len = obj.columns.length; i < len; i++) {
                if (i == 0) {
                    arr.push("合计");
                } else if (this.inArr(obj.columns[i].label, this.summaryKeys)) {
                    arr.push(1);
                } else {
                    arr.push("");
                }
            }

            return arr;
        },
        inArr(text, arr) {
            for (let i = 0, len = arr.length; i < len; i++) {
                if (text == arr[i]) {
                    return true;
                }
            }
            return false;
        },
        openWindow() {
            let url = window.location.href.split("#")[0];
            url += "#/jsonTypePage";
            url += `?json=${JSON.stringify(this.json)}`
            this.$openWindow(url);
        },
    },
};
</script>

<style lang="scss">
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
}
</style>


<style lang="scss">
.table-com {
    background: #fff;
    padding: 8px;
    border-radius: 4px;
}
.describe {
    color: #888;
    font-size: 14px;
}
.tools-bar {
    border-bottom: 1px dashed #888;
    overflow: hidden;
    padding-top: 8px;
    margin-right: -20px;
    .btn {
        color: #409eff;
        float: left;
        margin-right: 20px;
        margin-bottom: 8px;
        cursor: pointer;
    }
}
.title {
    font-size: 18px;
    text-align: center;
    line-height: 24px;
    margin: 6px 0;
    font-family: "黑体";
}
</style>


// WEBPACK FOOTER //
// src/vue/components/jsonType/table.vue